export default __webpack_public_path__ + "static/media/create-apps.3aa8dc9a.svg";